"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldTerminateCat = shouldTerminateCat;
const taskSetup_1 = require("../../taskSetup");
const finishExperiment_1 = require("../trials/finishExperiment");
const exemptTrialTypes = ['something-same-1'];
const eligibleAssessmentStages = [
    'test_response',
    'first_response',
    'second_response',
    'third_response',
    'fourth_response',
];
// ends the task if 4 of the last 10 trials have been incorrect
function shouldTerminateCat() {
    const data = taskSetup_1.jsPsych.data.get().filterCustom((trial) => {
        return (!exemptTrialTypes.includes(trial.corpusTrialType) && eligibleAssessmentStages.includes(trial.assessment_stage));
    });
    const lastTenTrials = data.last(10);
    const incorrectTrials = lastTenTrials.filter({ correct: false });
    const terminate = incorrectTrials.count() > 6;
    if (terminate) {
        (0, finishExperiment_1.finishExperiment)();
    }
}
